import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadLicensePlateStep1CustomerPopup,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadLicensePlateStep1CustomerPopup}
      content={CarleadHIWWhyChooseWkdaFaq}
      headlineDesktop="carleadCreation.form.title"
      headlineMobile="carleadCreation.form.step1.headline.mobile"
      showCounterHeadline={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
